import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { FormsModule } from '@angular/forms';
import { properties } from '../../environments/properties';
import { JsonRequest } from '../model/jsonRequest.model';
import { CoreApiService } from '../core/service/core-api-service';
import { AppService } from '../core/service/app.service';

@Component({
  selector: 'app-user-delete',
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    InputTextModule,
    FormsModule,
    InputTextareaModule,
  ],
  templateUrl: './user-delete.component.html',
  styleUrl: './user-delete.component.css',
})
export class UserDeleteComponent {
  constructor(
    private readonly apiService: CoreApiService,
    private readonly util: AppService,
  ) {}

  phone: any;
  contrasena: any;
  motivo: string = '';
  loading: boolean = false;

  deleteAccount(): void {
    this.util
      .mostrarConfirmacion('Está seguro que desea borrar el registro?', 1)
      .then((accept) => {
        const that = this;
        const body: JsonRequest = {
          data: JSON.stringify({
            usr_phone: this.phone,
            usr_password: this.contrasena,
            usr_delete_account: this.motivo,
          }),
          company: 1,
          fecha: new Date(),
        };

        this.apiService.consumirWSPost(
          properties.serviceDeleteUser,
          body,
          function (data) {
            if (data.estado === properties.codeOK) {
              that.util.mostrarToast(
                'Eliminación',
                'Se ha eliminado el registro',
                2,
              );
              that.phone = '';
              that.contrasena = '';
              that.motivo = '';
            } else {
              that.util.mostrarToast('Eliminación', data.error.mensaje, 4);
            }
          },
        );
      });
  }
}
